import angular from 'angular';

import topbarComponent from './topbar/topbar.component';
import navbarComponent from './navbar/navbar.component';
import datePickerComponent from './datepicker/datepicker.component';
import select2Component from './select2/select2.component';
import laddaButtonComponent from './ladda-button/ladda-button.component';
import paginationComponent from './pagination/pagination.component';
import pagination2Component from './pagination2/pagination2.component';
import toolTipComponent from './tooltip/tooltip.component';
import modalComponent from './modal/modal.component';
import switcheryComponent from './switchery/switchery.component';

import NavbarService from './navbar/navbar.service';
import PageService from './page.service';
import FormService from './form.service';
import ModalService from './modal/modal.service';

import AppFooterComponent from './app-footer/app-footer.component';

let uiModule = angular.module('app.ui', [])

.component('topbar', topbarComponent)
.component('navbar', navbarComponent)
.component('datePicker', datePickerComponent)
.component('select2', select2Component)
.component('laddaButton', laddaButtonComponent)
.component('pagination', paginationComponent)
.component('pagination2', pagination2Component)
.component('appFooter', AppFooterComponent)
.component('tooltip', toolTipComponent)
.component('modal', modalComponent)
.component('switchery', switcheryComponent)
.service('NavbarService', NavbarService)
.service('PageService', PageService)
.service('FormService', FormService)
.service('ModalService', ModalService)
.name;

export default uiModule;



// WEBPACK FOOTER //
// ./client/app/shared/ui/ui.module.js